var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeModalCommunityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10348_249687)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28ZM12.1345 5.94989C9.93532 5.94989 8.16951 7.71539 8.16951 9.91444C8.16951 12.1142 9.93524 13.8798 12.1345 13.8798C14.3337 13.8798 16.0994 12.1142 16.0994 9.91444C16.0994 7.71539 14.3336 5.94989 12.1345 5.94989ZM10.281 15.2926C8.14679 15.2926 6.41667 17.0227 6.41667 19.1569C6.41667 20.2054 7.26669 21.0555 8.31524 21.0555H15.737C16.7856 21.0555 17.6356 20.2054 17.6356 19.1569C17.6356 17.0227 15.9055 15.2926 13.7712 15.2926H10.281ZM17.0101 12.3615C16.7716 12.7375 16.9274 13.2709 17.3726 13.2709C19.3863 13.2709 21.003 11.6544 21.003 9.64023C21.003 7.62678 19.3862 6.01027 17.3726 6.01027C16.7082 6.01027 16.5715 6.83149 16.9426 7.38258C17.43 8.10633 17.7138 8.97997 17.7138 9.92329C17.7138 10.8225 17.4561 11.6584 17.0101 12.3615ZM20.9115 20.5927C19.9595 20.5927 19.1878 19.821 19.1878 18.869V18.1401C19.1878 17.3607 18.9094 16.6398 18.437 16.0532C18.1994 15.7583 18.3921 15.1763 18.7708 15.1763C20.905 15.1763 22.6351 16.8024 22.6351 18.8083V18.869C22.6351 19.821 21.8634 20.5927 20.9115 20.5927Z",
    fill: "#1A1B1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10348_249687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeModalCommunityIcon);
export default __webpack_public_path__ + "static/media/welcome-modal-community-icon.a8229142eb0e86b208bb0d0827349abf.svg";
export { ForwardRef as ReactComponent };